import React, { useState } from "react";
import { Modal } from "../../ui";
import { useAuthContext } from "../../context/AuthContext";
import Axios from "../../Axios";
import CoursePayout from "../../pages/Courses/CoursePayout";

import "./payModal.scss";

const logo = require("../../assets/logo-white.png");
const golomt = require("../../assets/bank-golomt-logo.png");
const khan = require("../../assets/bank-khan-logo.png");
const tdb = require("../../assets/bank-tdb-logo.png");
const videoFile = require("../../assets/payment_vid.mp4");

const PayModal = ({ id, visible, setVisible }) => {
  const { authConfig, logoutHandler } = useAuthContext();

  const [loading, setLoading] = useState(false);

  // ✅ зөв state
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentData, setPaymentData] = useState(null);

  // 🔥 CREATE INVOICE
  const handlePaymentClick = async () => {
    try {
      setLoading(true);

      const res = await Axios.post(
        "/users_courses/request",
        { courseID: id },
        authConfig
      );

      if (res.data.invoice) {
        const invoice = res.data.invoice;

        setPaymentData(invoice);

        // ✅ эхний modal хаана
        setVisible(false);

        // ✅ payment modal нээнэ
        setShowPaymentModal(true);
      } else {
        alert("Алдаа гарлаа");
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        setVisible(false);
        logoutHandler();
        return;
      }

      console.error(err);
      alert("Алдаа гарлаа");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* MAIN MODAL */}
      <Modal visible={visible} onCancel={setVisible}>
        <div className="payModal">
          <div className="payModal__content">
            {/* <img className="payModal__content-logo" src={logo} alt="" /> */}

            <ul className="payModal__content-banks">
              <li>
                <img src={golomt} alt="" />
              </li>
              <li>
                <img src={khan} alt="" />
              </li>
              <li>
                <img src={tdb} alt="" />
              </li>
            </ul>

            <div className="payModal__content-text">
              Та төлбөртэй хичээлийн төлбөр төлөх хэсэг рүү очихийг хүсвэл доорх
              товч дээр дарна уу
            </div>

            <button
              className="payModal__content-payBtn"
              onClick={handlePaymentClick}
              disabled={loading}
            >
              {loading ? "Түр хүлээнэ үү..." : "Төлбөрийн хэсэгт очих"}
            </button>
          </div>

          <video
            className="payModal__cover"
            src={videoFile}
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      </Modal>

      {/* ✅ PAYMENT MODAL */}
      {showPaymentModal && paymentData && (
        <Modal
          visible={showPaymentModal}
          onCancel={() => setShowPaymentModal(false)}
        >
          <CoursePayout
            {...paymentData}
            course_id={id}
          />
        </Modal>
      )}
    </>
  );
};

export default PayModal;
